<template>
  <div class="navbar-wrapper">
    <div class="container">
      <b-navbar>
        <template slot="brand">
          <b-navbar-item tag="router-link" :to="{ path: '/' }">
            <img src="../assets/icon.png" alt="Ivan Lencina logo" />
          </b-navbar-item>
        </template>
        <template slot="start">
          <b-navbar-item href="#">{{ $t("link.home") }}</b-navbar-item>
        </template>

        <template slot="end">
          <b-navbar-dropdown
            :label="language"
            :active="false"
            :collapsible="true"
          >
            <b-navbar-item @click="changeLanguage">{{
              oppositeLanguage
            }}</b-navbar-item>
          </b-navbar-dropdown>
        </template>
      </b-navbar>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import Languages from "../enums/language-enum";

@Component({
  computed: {
    ...mapGetters(["language"]),
    oppositeLanguage() {
      if (Languages.English === this.$store.getters.language) {
        return Languages.Spanish;
      }

      return Languages.English;
    },
  },
})
export default class Navbar extends Vue {
  language!: string; // <- for static type checking
  oppositeLanguage!: Languages; // Declare type for computed property

  public changeLanguage() {
    this.$store.dispatch("toggleLanguage");

    this.$i18n.locale = this.language;
  }
}
</script>

<style lang="scss" scoped>
div.navbar-wrapper {
  position: sticky;
  top: 0;
  width: 100vw !important;
  background-color: #fff;
  z-index: 100;
}
</style>
